import { FC } from 'react';
import { EFlex } from 'src/styles/layouts/Flex/Flex.enum';
import { StyledFlex } from './Flex.styles';
import { IFlex } from './Flex.type';

//https://github.com/Nodeguardians/ng-frontend#flex
const Flex: FC<IFlex> = ({
	children,
	direction = EFlex.row,
	horizontal = EFlex.start,
	vertical = EFlex.start,
	...otherProps
}) => {
	return (
		<StyledFlex direction={direction} horizontal={horizontal} vertical={vertical} {...otherProps}>
			{children}
		</StyledFlex>
	);
};

export { Flex };
